import React from 'react'
// @mui
import { styled } from '@mui/material/styles'
import { Container } from '@mui/material'
// sections
import LoginForm from './LoginForm'


// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      backgroundColor: "#0D9ED3"
    },
  }));
  
  const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: "center",
    
    padding: theme.spacing(12, 0),
    backgroundColor: ""
  }));
  
  // ----------------------------------------------------------------------


const Login = () => {
    return (
      <>
        <title> Login | Minimal UI </title>
        <StyledRoot>
          <Container maxWidth="sm">
            <StyledContent sx={{backgroundColor:""}}>
              <LoginForm />
              <div style={{ width: '100%', textAlign: 'center', position: 'absolute', bottom: '0px', color: 'white' }}>
                Copyright © 2024 VitaDX
              </div>
            </StyledContent>
          </Container>
        </StyledRoot>
      </>
    );
}
Login.propTypes = {
}

export default Login